import React from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { DATE_PRESETS, setDatePreset, formatDate, formatTime, DatePresetKey } from '../dateFormat';
import { useDatePreset } from '../useDatePreset';

/**
 * Lets the user choose how dates/times are displayed app-wide. The choice is
 * persisted per-device (localStorage) and applied live via useDatePreset.
 */
const DateFormatSelector: React.FC = () => {
  const { t } = useTranslation();
  const current = useDatePreset();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setDatePreset(e.target.value as DatePresetKey);
  };

  const now = new Date();

  return (
    <Form.Group controlId="dateFormatSelector" className="mb-3">
      <Form.Label className="fw-semibold">{t('dateFormat.label')}</Form.Label>
      <Form.Select value={current} onChange={handleChange} style={{ maxWidth: '300px' }}>
        {DATE_PRESETS.map(p => (
          <option key={p.key} value={p.key}>{t(p.labelKey)}</option>
        ))}
      </Form.Select>
      <Form.Text className="text-muted">
        {t('dateFormat.help')}: {formatDate(now)} {formatTime(now)}
      </Form.Text>
    </Form.Group>
  );
};

export default DateFormatSelector;
